import React from 'react';
import { useState, useEffect } from "react";

const API_BASE = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
	//? 'http://127.0.0.1:5002' 
	? 'http://127.0.0.1:5001/react-f303e/asia-northeast1'
	: '';

export const SteamApiApp = () =>
{
	const [games, setGames] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			//const url = "https://getsteamplayerclient-jl6opwdjea-an.a.run.app/";
			//const url = "/getSteamPlayerClient";
			try {
				const response = await fetch(`${API_BASE}/getSteamPlayerClient2`);
				const data = await response.json();
				console.log(data);
				setGames(data.data);
			}
			catch (err) {
				console.error(err);
			}
			finally {
			}
		};
		fetchData();
	}, []);

	return (
		<div className="container">
			<h2 className="mb-4">Steam 現在のプレイヤー数</h2>
			<div className="table-responsive">
				<table className="table table-hover table-striped border">
					<thead className="table-dark">
						<tr>
							<th>AppID</th>
							<th>ゲームタイトル</th>
							<th className="text-end">現在の人数</th>
						</tr>
					</thead>
					<tbody>
						{games && games.map((game, index) => (
						<tr key={index}>
							<td className="text-muted small">{game.appid}</td>
							<td>
								<a
									href={`https://store.steampowered.com/app/${game.appid}`} 
									target="_blank" 
									rel="noopener noreferrer"
									className="text-decoration-none text-dark"
								>
									<strong>{game.details.name}</strong>
								</a>
							</td>
							<td className="text-end font-monospace">
								{game.ccu.player_count}
							</td>
						</tr>
						))}
					</tbody>
				</table>
			</div>
			<p className="text-muted small">※ 1時間ごとに自動更新されます</p>
		</div>
	);
};
